//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderHeadCreateIbPurch', {
//        templateUrl: 'views/components/views/orderHeadCreateIbPurch/orderHeadCreateIbPurch.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'orderHeadCreateIbPurchService', 'logisticService', function ($stateParams, stateService, utilityService, orderHeadCreateIbPurchService, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderInternalNo = $stateParams.order_internal_no;
    		
//            vm.model = {
//                edit: {},
//                selectListStockPlaces: [],
//                lockedCreate: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await orderHeadCreateIbPurchService.getEdit({ order_internal_no: orderInternalNo }))[0];
//            }

//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;

//                return vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.edit.businessco_no });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON CREATE PROCEDURE FUNCTION CALL

//            vm.createChanges = function () {
//                vm.model.lockedCreate = true;

//                orderHeadCreateIbPurchService.createObj(vm.model.edit).then(() => {
//                    vm.model.lockedCreate = false;
//                    stateService.back();
//                }, () => vm.model.lockedCreate = false);
//            }

//            // #endregion BUTTON CREATE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadEdit();
//                loadStockPlaces();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
